export const HeaderText = {
    welcome: {
        english: 'Welcome',
        spanish: 'Bienvenidas'
    },
    lastLogin: {
        english: 'Last login:',
        spanish: 'Último acceso:',
    },
    logout: {
        english: 'LOG OUT',
        spanish: 'CERRAR SESIÓN'
    },
    language: {
        english: 'In English',
        spanish: 'En Español',
    },
    contactSupport: {
        english: 'Contact and support',
        spanish: 'Contacto y soporte'
    },
    profile: {
        english: 'Profile information',
        spanish: 'Información del perfil',
    },
    profileAndPermissions: {
        english: 'Profile and permissions',
        spanish: 'Perfil y permisos',
    },
    settings: {
        english: 'Security settings',
        spanish: 'Seguridad configuración',
    },
    commPrefs: {
        english: 'Alerts and notifications',
        spanish: 'Preferencia de comunicacion',
    },
    emailNotifications: {
        english: 'Email notifications',
        spanish: 'Notificaciónes de correo electrónico',
    },
    userAccess: {
        english: 'User access',
        spanish: 'Acceso de usuario',
    },
    viewing: {
        english: 'VIEWING: ',
        spanish: 'VISITA: ',
    },
    profileLinks: {
        english: 'Profile Side Links',
        spanish: 'Enlaces laterales del perfil',
    },
};
